module.exports = __webpack_public_path__ + "./images/footer--pattern.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/footer--pattern.png
// module id = 41
// module chunks = 3